import { render } from "./StaffPermissionManagement.vue?vue&type=template&id=5811c515&scoped=true"
import script from "./StaffPermissionManagement.vue?vue&type=script&lang=js"
export * from "./StaffPermissionManagement.vue?vue&type=script&lang=js"

import "./StaffPermissionManagement.vue?vue&type=style&index=0&id=5811c515&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5811c515"]])

export default __exports__